import { LinearProgress, Stack, Typography } from '@mui/material';

import { downloadTourImportCsvTemplate } from '@/domain/project-tour-ontour/actions/download-tour-import-csv-template.action';
import { importTourEventsFromCsv } from '@/domain/project-tour-ontour/actions/import-tour-events-from-csv';
import { selectProjecTourOnTourIsImportingTourEventsFromCsv } from '@/domain/project-tour-ontour/project-tour-ontour.selectors';
import { FSModal } from '@/ui/components/modal/FSModal';
import { FSModalTitle } from '@/ui/components/modal/FSModalTitle';
import { useAppDispatch, useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';

import { TourEventsFormValues } from '../tour-event-form-values/TourEventsFormValues';
import { DropOrSelectCsvFile } from './DropOrSelectCsvFile';
import { FileExampleView } from './FileExampleView';

export function ModalImportCsv({
  open,
  onClose,
  onImportTourEventsFormValues,
}: {
  open: boolean;
  onClose: () => void;
  onImportTourEventsFormValues: (formValues: TourEventsFormValues) => void;
}) {
  const dispatch = useAppDispatch();

  const isImporting = useAppSelector(
    selectProjecTourOnTourIsImportingTourEventsFromCsv,
  );

  const onClickDownloadCsvTemplate = () => {
    dispatch(downloadTourImportCsvTemplate());
  };

  const onCsvFileSelected = async (file: File) => {
    const text = await file.text();
    const formValues: TourEventsFormValues = await dispatch(
      importTourEventsFromCsv({ text }),
    ).unwrap();
    onImportTourEventsFormValues(formValues);
    onClose();
  };

  return (
    <FSModal open={open} onClose={onClose} showCloseButton maxWidth={800}>
      <Stack>
        <FSModalTitle
          title={translate('ProjectsTour.OnTour.ModalImportCsv.title')}
        />
        {isImporting ? (
          <InProgressView />
        ) : (
          <Stack sx={{ gap: 2, mt: 4 }}>
            <Stack sx={{ alignItems: 'center' }}>
              <FileExampleView
                onClickDownloadCsvTemplate={onClickDownloadCsvTemplate}
              />
            </Stack>
            <DropOrSelectCsvFile onCsvFileSelected={onCsvFileSelected} />
          </Stack>
        )}
      </Stack>
    </FSModal>
  );
}

function InProgressView() {
  return (
    <Stack sx={{ gap: 2, my: 2, py: 20, alignItems: 'center' }}>
      <Typography sx={{ fontSize: 20, fontWeight: 800 }}>
        {translate('ProjectsTour.OnTour.ModalImportCsv.import-csv-in-progress')}
      </Typography>
      <LinearProgress sx={{ width: 200 }} />
    </Stack>
  );
}
